//@ts-ignore
import React, { useState, useEffect } from 'react'
import { saveAndEditClient, getClient, getUsers, getClientRole, saveAndEditRole } from './ClientServices'
import { Link } from 'react-router-dom'
import { connect } from 'react-redux'
const styles = {
    padding: { padding: '5px 10px' }
}

const RoleComponent = (props: any) => {
    const [clientId, setClientId] = useState('')
    const [user, setUser] = useState('')
    const [roleName, setRoleName] = useState('')
    const [roleDes, setRoleDes] = useState('')
    const [allow, setAllow] = useState('')
    const [resMsg, setResMsg] = useState('')
    const [clients, setClients] = useState([])
    const [clientRoles, setClientRoles] = useState([])
    const [editRole, setEditRole] = useState(null)
    const [editRoleIndex, setEditRoleIndex] = useState(-1)
    useEffect(() => {
        getClient('')
            .then((res: any) => {
                setClients(res.responseObject)
            })
    }, [])
    const resetDetails = () => {
        setRoleName('')
        setRoleDes('')
        setAllow('')
        setEditRole(null)
        setEditRoleIndex(-1)
    }
    if ('rahul.khanna@edfora.com' === props.userData.authenticatedUser.email) {

        return (
            <div>
                <div>
                    <div style={{ float: 'right' }}>
                        <Link style={styles.padding} to="/client" >Client</Link>
                        <Link style={styles.padding} to="/user" >User</Link>
                        <Link style={styles.padding} to="/role" >Role</Link>
                        <Link style={styles.padding} to="/user-list" >User List</Link>
                    </div>

                    <div><p>{resMsg}</p></div>
                    <div style={styles.padding}>
                        <select value={clientId} onChange={(e) => {
                            setClientId(e.target.value)

                            getClientRole(e.target.value)
                                .then((res: any) => {
                                    const roles = res.responseObject
                                    // roles.pop()
                                    setClientRoles(roles)
                                })
                                .catch()
                        }}>
                            <option value=''> Select Client</option>
                            {clients.map((client: any) => {
                                return <option value={client._id}> {client.name}</option>
                            })}
                        </select>
                    </div>
                    <h2>{editRole ? 'Edit' : 'Create'} Role </h2>
                    <div style={styles.padding}>
                        <input type="text" onChange={(e) => { setRoleName(e.target.value) }} value={roleName} placeholder="Enter Rolename" />
                    </div>
                    <div style={styles.padding}>
                        <input type="text" onChange={(e) => { setRoleDes(e.target.value) }} value={roleDes} placeholder="Enter Role Des" />
                    </div>
                    <div style={styles.padding}>
                        <select value={allow} onChange={(e) => {
                            setAllow(e.target.value)
                        }}>
                            <option value='true'> Allow to all</option>
                            <option value='false'> Not allow to all</option>
                        </select>
                    </div>
                    <button
                        style={{ marginLeft: '10px' }}
                        onClick={(e) => {
                            e.preventDefault();
                            let body = {
                                clientId,
                                role: roleName,
                                description: roleDes,
                                allowAll: allow
                            }
                            saveAndEditRole(body, editRole ? editRole._id : null)
                                .then((res: any) => {
                                    if (editRole) {
                                        const roles = [...clientRoles]
                                        roles[editRoleIndex] = res.responseObject
                                        setClientRoles(roles)
                                    } else {
                                        setClientRoles([...clientRoles, res.responseObject.responseObject])
                                    }
                                    resetDetails()
                                })
                                .catch()
                        }}
                        disabled={clientId == '' || clientId == null || roleName == '' || roleDes == ''}
                    >
                        {editRole ? 'Edit' : 'Create'}
                    </button>
                    <button
                        onClick={(e) => {
                            e.preventDefault();
                            resetDetails()
                            setEditRole(null)
                        }}
                    >
                        Clear
                </button>
                </div>
                <div>
                    <h2>Roles List </h2>
                    <table>
                        <tr>
                            <td>S.no</td>
                            <td>Role Name</td>
                            <td>Role Des</td>
                            <td>Allow All</td>
                            <td>Action</td>
                        </tr>
                        {
                            clientRoles.map((role: any, index: number) => {
                                return <tr>
                                    <td>{index + 1}</td>
                                    <td>{role.role && role.role}</td>
                                    <td>{role.description && role.description}</td>
                                    <td>{role.allowAll && role.allowAll.toString()}</td>
                                    <td><button
                                        onClick={(e) => {
                                            e.preventDefault();
                                            setRoleName(role.role)
                                            setRoleDes(role.description)
                                            setAllow(role.allowAll.toString())
                                            setEditRole(role)
                                            setEditRoleIndex(index)
                                        }}
                                    >
                                        Edit
                            </button></td>
                                </tr>
                            })
                        }
                    </table>
                </div>
            </div>
        )
    } else {
        return <h1> Not permitted </h1>
    }
}


const mapStateToProps = (state: any) => ({
    userData: state.loginData.userData
})


export default connect(mapStateToProps)(RoleComponent);
